import { createSelector } from 'reselect'
import { createGetter, composeGetters } from 'react-redux-getters'
import { getCollection, replaceCollections } from '@fakundo/redux-entities'
import sortBy from 'lodash/sortBy'
import padStart from 'lodash/padStart'
import { fetchCurrencies, fetchTimezones, fetchPlans } from 'actions/static'
import { CURRENCIES, TIMEZONES, PLANS } from 'constants/entityNames'

export const getCurrencies = createGetter({
  stateSelector: state => getCollection(state, CURRENCIES),
  asyncFetcher: dispatch => dispatch(fetchCurrencies()),
  stateUpdater: (currencies, dispatch) => dispatch(replaceCollections({
    [CURRENCIES]: currencies
  })),
})

export const getTimezones = createGetter({
  stateSelector: state => getCollection(state, TIMEZONES),
  asyncFetcher: dispatch => dispatch(fetchTimezones()),
  stateUpdater: (timezones, dispatch) => dispatch(replaceCollections({
    [TIMEZONES]: timezones
  })),
})

export const getTimezoneCities = createSelector(
  getTimezones,
  timezonesGetter => composeGetters(
    timezonesGetter,
    timezonesData => sortBy(timezonesData.map(timezone => ({
      ...timezone,
      name: timezone.code.replace(/^.+?\/(.+)/, '$1').replace(/_/g, ' '),
      offsetString: `UTC${timezone.offset >= 0 ? '+' : '-'}${padStart(Math.abs(parseInt(timezone.offset / 60, 10)), 2, '0')}:${padStart(Math.abs(timezone.offset % 60), 2, '0')}`
    })), 'name')
  )
)

export const getPlans = createGetter({
  stateSelector: state => getCollection(state, PLANS),
  asyncFetcher: dispatch => dispatch(fetchPlans()),
  stateUpdater: (plans, dispatch) => dispatch(replaceCollections({ [PLANS]: plans })),
})
